import { AuthStrategy } from './auth.interfaces';
import * as authActions from './auth.actions';
export const AUTH_INITIAL_STATE = {
    loggedIn: false,
    settingUser: false,
    user: undefined,
    loginFailed: false,
    authStrategy: AuthStrategy.OKTA,
    userType: undefined,
    isAuthenticated: false,
    authenticationStarted: false,
    authenticationEnded: false,
    oktaUserclaim: undefined
};
/**
 * Ngrx reducer for the auth state, this updates the state for the login/logout success actions
 *
 * @export
 * @param [state=AUTH_INITIAL_STATE]
 * @param action
 * @returns { Auth } Updated state or the default state
 */
export function authReducer(state = AUTH_INITIAL_STATE, action) {
    switch (action.type) {
        case authActions.SET_AD_USER: {
            return { ...state, settingUser: true };
        }
        case authActions.LOGIN_SUCCESS: {
            return {
                ...state,
                user: action.payload,
                loggedIn: true,
                loginFailed: false,
                settingUser: false
            };
        }
        case authActions.LOGIN_FAILED: {
            return { ...state, user: undefined, loggedIn: false, loginFailed: true, settingUser: false };
        }
        case authActions.LOGOUT_SUCCESS: {
            return { ...state, user: undefined, loggedIn: false, loginFailed: false, settingUser: false };
        }
        case authActions.SET_USER_TYPE: {
            return { ...state, userType: action.payload };
        }
        case authActions.SET_AUTH_TYPE: {
            return { ...state, authStrategy: action.payload };
        }
        case authActions.SET_IS_AUTHENTICATED: {
            return { ...state, isAuthenticated: action.payload };
        }
        case authActions.SET_AUTHENTICATION_STARTED: {
            return { ...state, authenticationStarted: action.payload };
        }
        case authActions.SET_AUTHENTICATION_ENDED: {
            return { ...state, authenticationEnded: action.payload };
        }
        case authActions.SET_OKTA_USERCLAIM: {
            return { ...state, oktaUserclaim: action.payload };
        }
        default: {
            return state;
        }
    }
}
export const isLoggedIn = (state) => state.loggedIn;
export const getADUser = (state) => state.user;
export const isSettingUser = (state) => state.settingUser;
export const loginFailed = (state) => state.loginFailed;
export const getInternalUserToken = (state) => state.user.profile.token;
export const userType = (state) => state.userType;
export const getAuthStrategy = (state) => state.authStrategy;
export const getIsAuthenticated = (state) => state.isAuthenticated;
export const getAuthenticationStarted = (state) => state.authenticationStarted;
export const getAuthenticationEnded = (state) => state.authenticationEnded;
export const getOktaUserclaim = (state) => state.oktaUserclaim;
//# sourceMappingURL=auth.reducer.js.map